import { useRecoilState } from 'recoil';
import { CampaignInfo, campaignInfoAtom } from '../internal/atom';
import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useCampaignContext = () => {
  const location = useLocation();

  const [campaignInfo, setCampaignInfo] = useRecoilState(campaignInfoAtom);

  const showBackToCampaignButton = Boolean(campaignInfo.campaignId);

  const setCampaign = (campaignInfo: CampaignInfo) => {
    setCampaignInfo(campaignInfo);
  };

  const clearCampaign = useCallback(
    () =>
      setCampaignInfo({
        campaignId: '',
        campaignType: '',
      }),
    [setCampaignInfo]
  );

  useEffect(() => {
    if (showBackToCampaignButton) {
      const path = location.pathname.split('/');
      if (
        !(
          path.includes('productdetails') ||
          path.includes('quotemgmt') ||
          path.includes('tsinvoicedetail') ||
          path.includes('repeat-opportunity')
        )
      ) {
        clearCampaign();
      }
    }
  }, [clearCampaign, location, showBackToCampaignButton]);

  return {
    campaignInfo,
    setCampaign,
    showBackToCampaignButton,
  };
};
